module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5949_-_Cia_Termal_Beachewear_-_Moda_Feminina.d7eb4e72.jpg";